'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWbSunny = function MdWbSunny(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5.9 30.9l3-3 2.4 2.3-3 3.1z m12.5 6.5v-4.9h3.2v4.9h-3.2z m1.6-28.3c5.5 0 10 4.5 10 10s-4.5 10-10 10-10-4.4-10-10 4.5-10 10-10z m13.4 8.4h5v3.4h-5v-3.4z m-4.6 12.7l2.3-2.2 3 2.9-2.4 2.4z m5.3-22.8l-3 3-2.3-2.3 2.9-3z m-12.5-6.5v5h-3.2v-5h3.2z m-15 16.6v3.4h-5v-3.4h5z m4.7-9.5l-2.4 2.4-3-3 2.4-2.3z' })
        )
    );
};

exports.default = MdWbSunny;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wb-sunny.js
// module id = 3464
// module chunks = 0